import React from 'react';
import style from './index.scss';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { TTButton } from '../../components/TableComponents';
import { Layout } from 'antd';
import { clearUploadTypologies } from '../../../../redux/actions/trm/trmDashboard';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';
const { Content } = Layout;
/**
 * UploadSuccess Widget
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const UploadSuccess = (props) => {
  return (
    <Content className={style.content}>
      <div
        style={{
          maxWidth: 650,
          margin: '0 auto',
          marginTop: 90,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
        <CheckCircleTwoTone
          style={{ fontSize: 60, marginBottom: 27 }}
          twoToneColor="#52c41a"
        />
        <div
          style={{
            textAlign: 'center',
            marginBottom: 60
          }}
          className={style.upload_icon_text}>
          TMI file is Uploaded.
        </div>
        <TTButton
          routeToGo={'/app/trm/dashboard'}
          onRedirect={props.clearUploadTypologies}
          btnText={'Back to Typology Listing'}
        />
      </div>
    </Content>
  );
};

/**
 * propTypes
 */

UploadSuccess.propTypes = {
  clearUploadTypologies: Proptypes.func
};

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    clearUploadTypologies: (payload) => {
      dispatch(clearUploadTypologies());
    }
  };
}

export default connect(null, mapDispatchToProps)(UploadSuccess);
